<a [id]="id" (click)="onClick()" [className]="classname">
    <ng-content></ng-content>
</a>